import { isMiniApp, isWeChatMiniProgram, isWeb, isByteDanceMicroApp, isKuaiShouMiniProgram, isBaiduSmartProgram } from "@uni/env";
import aliMiniAppModule from "./ali-miniapp/index";
import weChatModule from "./wechat-miniprogram/index";
import bytedanceModule from "./bytedance-microapp/index";
import webModule from "./web/index";
import kuaiShouModule from "./kuaishou-miniprogram/index";
import baiDuModule from "./baidu-smartprogram/index";
export var push = function push(options) {
  if (isWeb) {
    return webModule.push(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.push(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.push(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.push(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.push(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.push(options);
  } else {
    throw new Error('Uni API：navigate.push 暂不支持');
  }
};
export var go = function go(options) {
  if (isWeb) {
    return webModule.go(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.go(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.go(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.go(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.go(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.go(options);
  } else {
    throw new Error('Uni API：navigate.go 暂不支持');
  }
};
export var back = function back(options) {
  if (isWeb) {
    return webModule.back(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.back(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.back(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.back(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.back(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.back(options);
  } else {
    throw new Error('Uni API：navigate.back 暂不支持');
  }
};
export var replace = function replace(options) {
  if (isWeb) {
    return webModule.replace(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.replace(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.replace(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.replace(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.replace(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.replace(options);
  } else {
    throw new Error('Uni API：navigate.replace 暂不支持');
  }
};
export var reLaunch = function reLaunch(options) {
  if (isWeb) {
    return webModule.reLaunch(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.reLaunch(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.reLaunch(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.reLaunch(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.reLaunch(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.reLaunch(options);
  } else {
    throw new Error('Uni API：navigate.reLaunch 暂不支持');
  }
};
export var switchTab = function switchTab(options) {
  if (isWeb) {
    return webModule.switchTab(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.switchTab(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.switchTab(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.switchTab(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.switchTab(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.switchTab(options);
  } else {
    throw new Error('Uni API：navigate.switchTab 暂不支持');
  }
};
export default {
  push: push,
  back: back,
  reLaunch: reLaunch,
  switchTab: switchTab,
  replace: replace,
  go: go
};